<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M14.375 8.125H18.125V4.375"
      :stroke="props.color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.7183 15.0003C13.7355 15.9277 12.5013 16.5449 11.1697 16.7748C9.83816 17.0047 8.46838 16.8371 7.23153 16.293C5.99468 15.7488 4.9456 14.8523 4.21537 13.7153C3.48513 12.5784 3.10614 11.2515 3.12572 9.90034C3.14531 8.54923 3.56262 7.23385 4.3255 6.11855C5.08838 5.00325 6.16301 4.13749 7.41512 3.62944C8.66723 3.1214 10.0413 2.99359 11.3656 3.262C12.6899 3.5304 13.9058 4.18311 14.8613 5.13858L18.1246 8.1253"
      :stroke="props.color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
  interface Props {
    size?: number | string;
    color?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    size: 20,
    color: "currentColor",
  });
</script>
